<template>
  <path fill="currentColor" d="M10 14L6 10L4 12L10 18L20 8L18 6L10 14Z" />
</template>
